export const GET_TOKEN = "GET_TOKEN";
export const MAKE_PAYMENT="MAKE_PAYMENT";